module.exports = __webpack_public_path__ + "img/mo-contact-logo.1912c0ea.png";